export const staticOfacRestriction = {
  forType: (type: string) => ({
    trigger: `Who can take this ${type}?`,
    description: `Unfortunately, learners residing in one or more of the following
        countries or regions will not be able to register for this ${type}:
        Iran, Cuba and the Crimea region of Ukraine. While edX has sought
        licenses from the U.S. Office of Foreign Assets Control (OFAC) to offer
        our ${type}s to learners in these countries and regions, the licenses we
        have received are not broad enough to allow us to offer this ${type} in
        all locations. edX truly regrets that U.S. sanctions prevent us from
        offering all of our ${type}s to everyone, no matter where they live.`,
  }),
};
